/* eslint-disable default-case */
/* eslint-disable consistent-return */
import React from 'react';
import i18next from 'i18next';

import Notice, {NoticeSeverity} from 'web-app/react/components/form-elements/notice/notice';
import {s4} from 'web-app/styleguide/spacing';
import {Base} from 'web-app/react/components/layout/layout';
import Link from 'web-app/react/components/link/link';
import {navigationContext} from 'web-app/react/contexts/navigation';

import {type LoginError, LoginErrorState} from './models';

interface InputProps {
    error: LoginError;
    email?: string;
}
const LoginErrorRenderer: React.FC<React.PropsWithChildren<InputProps>> = ({error, email}) => {
    const {generateUrl} = React.useContext(navigationContext);

    if (!shouldRender(error)) {
        return null;
    }

    const title = errorCodeToTitle(error);
    const message = errorCodeToDescription(error, generateUrl, email);
    return (
        <Base marginBottom={s4} id="loginError">
            <Notice severity={NoticeSeverity.ERROR} withHeader={Boolean(title)} title={title} message={message} />
        </Base>
    );
};

export default LoginErrorRenderer;

const shouldRender = (error: LoginError) => {
    switch (error.errorCode) {
        case LoginErrorState.INVALID_PIN:
            return false;
        default:
            return true;
    }
};

const errorCodeToTitle = (error: LoginError) => {
    if (error.title) {
        return error.title;
    }

    switch (error.errorCode) {
        case LoginErrorState.INVALID_PASSWORD:
            return i18next.t('login.incorrectPassword');
        case LoginErrorState.EMAIL_DOES_NOT_EXIST:
            return i18next.t('login.emailDoesNotExists');
        case LoginErrorState.TOO_MANY_CREDENTIAL_APPEMPTS:
            return i18next.t('login.accountBlocked');
        case LoginErrorState.TOO_MANY_PIN_ATTEMPTS:
            return i18next.t('login.invalidPIN');
        case LoginErrorState.TWO_FACTOR_REQUIRED:
            return error.error;
    }
};

const errorCodeToDescription = (
    error: LoginError,
    generateUrl: (route: string, ...args: any) => string,
    email?: string,
) => {
    if (error.description) {
        return error.description;
    }

    switch (error.errorCode) {
        case LoginErrorState.INVALID_PASSWORD:
            return (
                <div>
                    {i18next.t('login.wrongLogin')}
                    {email ? (
                        <div>
                            <Link id="forgotPassword" href={generateUrl('forgotPassword', {queryParams: {email}})}>
                                {i18next.t('login.clickToResetPassword')}
                            </Link>
                        </div>
                    ) : null}
                </div>
            );
        case LoginErrorState.EMAIL_DOES_NOT_EXIST:
            return i18next.t('login.emailDoesNotExistsDescription');
        case LoginErrorState.TOO_MANY_CREDENTIAL_APPEMPTS:
            return i18next.t('login.tooManyFailedLoginsExplanation');
        case LoginErrorState.TWO_FACTOR_REQUIRED:
            return i18next.t('login.twoFactorErrorExplanation');
        default:
            return error.error;
    }
};
